import React from 'react';
import PageHeader from './Header';
import SearchBar from './SearchBar';

import MapMain from './MapMain';
import Setting from './Setting';

import { Layout,  Row, Col } from 'antd';
const { Header, Footer, Sider, Content } = Layout;

const EconomicProfilePage = () => (
  <Layout>
    <Header className="header">
      <PageHeader />
    </Header>

    <Content>
      <Row>
        <SearchBar background="black" />
      </Row>
      <Row>
          <div className="map-container">
            <MapMain />
          </div>
            <Setting />
      </Row>
    </Content>
    </Layout>
);

export default EconomicProfilePage;



// WEBPACK FOOTER //
// ./src/components/EconomicProfilePage.js